// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ee594686] .el-dialog__body {\n  padding: 10px 10px;\n  height: 440px;\n  overflow: auto;\n}\n.el-form-item--mini.el-form-item[data-v-ee594686] {\n  margin-bottom: 10px;\n}\n.video .el-upload-list--picture-card .el-upload-list__item[data-v-ee594686] {\n  width: 250px;\n  height: 100px;\n}", ""]);
// Exports
module.exports = exports;
